export default __webpack_public_path__ + "static/media/partner-17.af20b698.png";